export default "<h3>October 11, 2018</h3>\r\n<p>Update 0.35 fixes bugs and makes balancing changes.</p>";